goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ChevronDown$default");
shadow.js.shim.module$$carbon$icons_react$es$ChevronDown$default = shadow.js.require(353, {}).default;
